import { type Control, Controller } from 'react-hook-form'
import { Combobox } from '@/components/inputs/combobox'
import { IzzyGreeting } from '@/components/izzy/greetings'
import type { MatchCoursesFormType } from '@/schemas/education/match-courses-schema'
import { useStudentTransferDesiredCourseStep } from './hooks/use-student-transfer-desired-course-step'

type StudentTransferDesiredCourseStepProps = {
  control?: Control<MatchCoursesFormType>
}

export const StudentTransferDesiredCourseStep = ({
  control
}: StudentTransferDesiredCourseStepProps) => {
  const {
    states: { coursesOptions, isLoading },
    actions: { handleDesiredCourseSelect }
  } = useStudentTransferDesiredCourseStep()

  return (
    <div className="relative w-full flex flex-col mt-7 min-h-68 gap-5">
      <IzzyGreeting
        label={
          <p>
            Agora é só escolher seu curso e eu vou analisar suas equivalências!
          </p>
        }
        className="w-48 right-10 absolute z-20"
      />
      <label
        htmlFor="desired-course-input"
        className="font-bold text-muted-foreground/60"
      >
        Selecione o curso desejado para aproveitamento
      </label>
      <Controller
        name="desiredEducation"
        control={control}
        render={({ field }) => (
          <Combobox
            className="w-full"
            label="Curso desejado"
            items={coursesOptions}
            notFoundMessage="Nenhum curso encontrado..."
            placeholder="Curso desejado..."
            loadingOptions={isLoading}
            selectedValue={field.value?.desiredEducationId}
            onChange={(item) => handleDesiredCourseSelect(field, item)}
          />
        )}
      />
    </div>
  )
}
